import React, {useState, useEffect} from 'react';
import * as S from './otp.styles';

const ResendBlock = ({resendOTP, type, resendVisible}) => {
  const [showResendOTP, setShowResendOTP] = useState(false);

  useEffect(() => {
    let isMount = true;
    const timer = setTimeout(() => {
      if(isMount){
        setShowResendOTP(true);

      }
    }, 5000);

    return ()=>{
      isMount = false;
      clearTimeout(timer);
    }
  }, []);

  if (!showResendOTP) {
    return (
      <S.ResendBlock>
        <S.ResendTextDisabled>Resend OTP</S.ResendTextDisabled>
      </S.ResendBlock>
    );
  }

  return resendVisible ? (
    <S.ResendBlock>
      <S.ResendText onClick={() => resendOTP(type)}>Resend OTP</S.ResendText>
    </S.ResendBlock>
  ) : (
    <S.ResendBlock>
      <S.ResendTextDisabled>Resend OTP</S.ResendTextDisabled>
    </S.ResendBlock>
  );
};

const OTPBlock = (
  {label, subLabel, otpLength, type, error, resendOTP, autoFocus, resendVisible},
  ref,
) => {
  const [activeTabId, setActiveTabId] = useState(autoFocus ? `${type}1` : '');
  const [value, setValue] = useState([]);

  const onKeyUpEvent = (e, type, index) => {
    const eventCode = e.which || e.keyCode;
    const valueStr = e.target.value;
    const len = otpLength;
    const ele = getInputElement(type, index);
    if (valueStr.length === 1) {
      if (index !== len) {
        setActiveTabId(`${type}${index + 1}`);
      } else {
        ele.blur();
        index = 0;
      }
    } else if (valueStr.length > 1) {
      return;
    }
    if (eventCode === 8 && index !== 1) {
      setActiveTabId(`${type}${index - 1}`);
    }
  };

  const onFocusEvent = (type, index) => {
    setActiveTabId(`${type}${index}`);
  };

  const onChangeHandler = (e, index, valueStr) => {
    const value = e.target.value;
    if (value.length <= 1) {
      const temp = valueStr.slice();
      temp[index] = value;
      setValue(temp);
    }
  };

  const getInputElement = (type, index) => {
    return document.getElementById(`${type}${index}`);
  };

  const OTPInput = ({index, fieldValue}) => {
    return (
      <S.OtpInput
        id={`${type}${index + 1}`}
        // autoFocus={activeTabId === `${type}${index + 1}`}
        // added to make sure the input at last index doesn't gain focus when typing in any other field than OTP
        autoFocus={fieldValue?.join('').length == otpLength ? false : activeTabId === `${type}${index + 1}`}
        type="number"
        maxLength="1"
        value={fieldValue[index] || ''}
        onChange={e => onChangeHandler(e, index, fieldValue)}
        onKeyUp={e => onKeyUpEvent(e, type, index + 1)}
        onFocus={() => onFocusEvent(type, index + 1)}
        hasError={error ? true : false}
      ></S.OtpInput>
    );
  };

  const resetBlock = () => {
    setValue([]);
    setActiveTabId('');
  }

  const resendOTPCallback = type => {
    resendOTP(type);
    resetBlock();
  };

  return (
    <S.OtpInputInnerWrapper>
      <S.OtpInputWrapper>
        <S.OtpInputBlock>
          <S.OtpInputLabel>
            {label} <S.OtpInputSubLabel>{subLabel}</S.OtpInputSubLabel>
          </S.OtpInputLabel>
          <S.OtpBlockWrap>
            <S.OtpBlockInnerotpWrap>
              <S.OtpMainWrap>
                {Array(otpLength)
                  .fill(1)
                  .map((val, index) => (
                    <OTPInput key={`${type}${index}`} index={index} fieldValue={value} />
                  ))}
                <input ref={ref} type="hidden" name={`${type}OTP`} value={value.join('')} />
              </S.OtpMainWrap>
              <S.ErrorText>{error}</S.ErrorText>
            </S.OtpBlockInnerotpWrap>
            <S.OtpBlockresendWrap>
              <ResendBlock resendOTP={resendOTPCallback} type={type} resendVisible={resendVisible} />
            </S.OtpBlockresendWrap>
          </S.OtpBlockWrap>
        </S.OtpInputBlock>
      </S.OtpInputWrapper>
    </S.OtpInputInnerWrapper>
  );
};

export default React.forwardRef(OTPBlock);
